import { PreviewRenderer, PreviewStage } from "./PreviewStage";
import React from "react";

import { v3 } from "oc-threejs/short3";
import * as Scenes from "oc-threejs/Scenes";
import { useDummy3dCloneInScene } from "../inputs/Model3dInput";
import { Group } from "three";

export const MaterialPreview = ({ node, nodeIndex, isTopNode }) => {
  const { addDummyCheckbox, setDummy3d } = useDummy3dCloneInScene({ node, isTopNode });
  return (
    <React.Fragment>
      <PreviewStage
        className="material-preview"
        changeDependencies={[node.threeValue.uuid, nodeIndex]}
        appScene={APP.scene}
        initStage={(stage: PreviewRenderer) => {
          const materialDummy3d = new Group();
          stage.scene.add(materialDummy3d);
          APP.sceneNode.getPreviewModelPromise(node.threeValue).then((object3d) => {
            materialDummy3d.add(object3d);
            stage.zoomTo(materialDummy3d, { direction: v3(0, 0.5, 0.5).normalize() });
            const sphere = Scenes.boundingSphere(object3d);
            stage.addGridSkyAndGround(sphere.radius);
            stage.addBackgroundBoxes(sphere.radius);
            setDummy3d(materialDummy3d);
          });
          window["previewScene"] = stage.scene;
          // stage.autoRotate();
        }}
      />
      {addDummyCheckbox}
    </React.Fragment>
  );
};
